import React, { useState } from 'react';
import BoxIcon from '../Icons/BoxIcon';
import CodeSlash from '../Icons/CodeSlash';

const ServiceSection = () => {
    let [activeCard, setActiveCard] = useState(0);

    let content = [
        {
            num: '01',
            icon: CodeSlash,
            heading: 'Backend Systems',
            content: `Designing and building secure, scalable backend systems with REST APIs, authentication, and role-based access control. Focused on clean architecture, performance, and real-world reliability.`
        },
        {
            num: '02',
            icon: BoxIcon,
            heading: 'Scalable Web Apps',
            content: `Building production-ready web applications using MERN & Next.js, structured to handle real users, high traffic, and business-critical workflows from day one.`
        },
        {
            num: '03',
            icon: BoxIcon,
            heading: 'Performance Optimization',
            content: `Improving system performance by optimizing database queries, reducing latency, and ensuring applications run efficiently under load with smooth user experience.`
        },
        {
            num: '04',
            icon: CodeSlash,
            heading: 'System Design',
            content: `Designing scalable architectures, workflows, and data models for complex applications, ensuring maintainability, flexibility, and long-term growth.`
        },
        {
            num: '05',
            icon: BoxIcon,
            heading: 'DevOps & Deployment',
            content: `Deploying and managing applications on VPS using Nginx, PM2, SSL, and DNS configurations, ensuring stable and reliable production environments.`
        }
    ];

    return (
        <section id='service' className='min-h-[60vh] relative py-20 overflow-hidden' >
            {/* Background Text */}
            <h5 className='absolute top-1/2 -translate-y-1/2 -left-0 opacity-10
             font-bold uppercase rotate-180
             text-[10rem] md:text-[14rem] lg:text-[16rem] bebas vrl 
             pointer-events-none select-none text-violet-300 z-0'>
                Expertise
            </h5>

            <div className='container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full max-w-7xl' >
                {/* Header */}
                <div className="mb-12 md:mb-16 md:px-4 text-center md:text-left flex flex-col md:items-start items-center">
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-100 poppins mb-4">
                        Core <span className="txtclr"> Expertise</span>
                    </h2>
                    <p className="text-slate-400 text-left max-w-2xl text-lg md:text-xl">
                        Delivering robust, scalable, and optimized solutions tailored to your business needs.
                    </p>
                </div>

                {/* Cards Grid Component */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 place-items-center md:place-items-stretch">
                    {content.map((obj, index) => (
                        <div key={index} onClick={() => setActiveCard(index)} className="w-full focus:outline-none h-full">
                            <div
                                className={`relative group rounded-3xl p-6 md:p-8 cursor-pointer transition-all duration-500 ease-in-out border overflow-hidden poppins flex flex-col justify-between mx-auto shadow-lg md:h-full w-full max-w-[400px] md:max-w-none
                                    ${activeCard === index
                                        ? "bgclr border-violet-400 text-slate-900 scale-100 shadow-[0_0_30px_rgba(139,92,246,0.25)]"
                                        : "bgclr1 border-slate-800 text-slate-100 hover:border-violet-500/50 hover:scale-[1.02] hover:shadow-xl"}`}
                            >
                                {/* Top Section */}
                                <div className="flex justify-between items-start mb-8">
                                    <div className={`text-5xl font-bold font-serif opacity-30 transition-colors duration-300 ${activeCard === index ? 'text-slate-800' : 'text-slate-500'}`}>
                                        {obj.num}
                                    </div>
                                    <div className={`p-3 rounded-2xl transition-transform duration-500`}>
                                        <obj.icon size={32} />
                                    </div>
                                </div>

                                {/* Content Section */}
                                <div className="mt-auto flex flex-col justify-end">
                                    <h4 className={`text-2xl md:text-3xl font-bold tracking-wide mb-2 bebas transition-colors duration-300 ${activeCard === index ? 'text-slate-900' : 'text-slate-200'}`}>
                                        {obj.heading}
                                    </h4>
                                    <div
                                        className={`grid transition-all duration-500 ease-in-out ${activeCard === index ? 'grid-rows-[1fr] opacity-100 mt-4' : 'grid-rows-[0fr] opacity-0'}`}
                                    >
                                        <p className="text-sm md:text-base leading-relaxed overflow-hidden opacity-90 font-medium">
                                            {obj.content}
                                        </p>
                                    </div>
                                </div>

                                {/* Bottom glowing highlight line for active card */}
                                {activeCard === index && (
                                    <div className="absolute bottom-0 left-0 h-[6px] w-full bg-gradient-to-r from-violet-700 via-fuchsia-600 to-violet-700 shadow-[0_-5px_15px_rgba(139,92,246,0.6)]"></div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceSection;